export default {
  label: {
    color: 'text.dark',
    fontWeight: '300',
  },
  placeholder: {
    color: 'text.grey.blue_1',
  },
  select: {
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: '300',
      lineHeight: '1.15',
      pl: 2,
      py: 1.25,
      '& .MuiTypography-root': {
        fontSize: '14px',
        fontWeight: '300',
        lineHeight: '1.15',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'background.grey.blue_3',
    },
    '&:hover ': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'background.grey.blue_3',
      },
    },
    '& .MuiSelect-icon': {
      right: '8px',
      top: '50%',
      transform: 'translateY(-50%)',
    },
  },
  valueContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 1,
  },
  valueText: {
    m: 0,
  },
};
